import { Menu, MenuItem } from '@mui/material'
import plur from 'plur'
import { useState } from 'react'
import menuArrow from '../images/menu-arrow.svg'
import noop from 'lodash/noop'

interface CustomSelectProps {
  label: string
  options: string[]
}

const CustomSelect = ({ label, options }: CustomSelectProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }
  return (
    <div>
      <div
        onClick={options.length > 0 ? handleClick : noop}
        role={options.length > 0 ? 'button' : undefined}
        className="text-[14px] py-[2px] px-2 m-0 text-black font-normal font-decimal w-[209px] border-[1px] border-black bg-white flex justify-between"
      >
        <span>
          {`${options ? options.length : 0} ${plur(
            label,
            options ? options.length : 0
          )} ${label === 'Form' ? 'of Repair' : ''}`}
        </span>
        {options.length > 0 && <img src={menuArrow} alt="down arrow" />}
      </div>
      <Menu
        MenuListProps={{
          'aria-labelledby': 'demo-customized-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        sx={{
          border: '1px solid #222222',
          padding: '8px 2px',
        }}
      >
        {(options || []).map((d, i) => (
          <MenuItem
            key={`menu-item-for-${d}`}
            sx={{
              fontSize: '12px',
              color: '#222222',
              fontFamily: 'Montserrat',
              margin: 0,
              padding: '8px',
              border: 'none',
              whiteSpace: 'normal',
              backgroundColor: '#e9e7e1!important',
              width: '209px',
            }}
          >
            {`${i + 1}. ${d}`}
          </MenuItem>
        ))}
      </Menu>
    </div>
  )
}
export default CustomSelect
